import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function ApiPaymentPlanPage() {
  return <DocPageLayout title="Payment Plan API" description="Operations related to managing Payment Plans for recurring and installment payments." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Payment Plan'
  }]} sections={[{
    id: 'create-plan',
    title: 'Create Payment Plan'
  }, {
    id: 'update-plan',
    title: 'Update Payment Plan'
  }, {
    id: 'retrieve-plan',
    title: 'Retrieve Payment Plan'
  }]} data-id="element-598">
      <h2 id="create-plan" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-599">
        Create Payment Plan
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-600">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-700 mr-2" data-id="element-601">
          POST
        </span>
        <span className="text-gray-600" data-id="element-602">/merchant/</span>
        <span className="text-blue-600" data-id="element-603">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-604">/paymentPlan/</span>
        <span className="text-blue-600" data-id="element-605">{'{planId}'}</span>
      </div>
      <CodeBlock language="JSON" title="Request" code={`{
  "planType": "RECURRING",
  "name": "Monthly Premium Plan",
  "description": "Premium subscription billed monthly",
  "amount": "49.99",
  "currency": "USD",
  "frequency": "MONTHLY",
  "numberOfPayments": 12,
  "startDate": "2026-04-01"
}`} data-id="element-606" />

      <h2 id="retrieve-plan" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-607">
        Retrieve Payment Plan
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-608">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 mr-2" data-id="element-609">
          GET
        </span>
        <span className="text-gray-600" data-id="element-610">/merchant/</span>
        <span className="text-blue-600" data-id="element-611">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-612">/paymentPlan/</span>
        <span className="text-blue-600" data-id="element-613">{'{planId}'}</span>
      </div>

      <h2 id="update-plan" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-614">
        Update Payment Plan
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-615">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 mr-2" data-id="element-616">
          PUT
        </span>
        <span className="text-gray-600" data-id="element-617">/merchant/</span>
        <span className="text-blue-600" data-id="element-618">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-619">/paymentPlan/</span>
        <span className="text-blue-600" data-id="element-620">{'{planId}'}</span>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-621">
        Cancel Payment Plan
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-622">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-700 mr-2" data-id="element-623">
          DELETE
        </span>
        <span className="text-gray-600" data-id="element-624">/merchant/</span>
        <span className="text-blue-600" data-id="element-625">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-626">/paymentPlan/</span>
        <span className="text-blue-600" data-id="element-627">{'{planId}'}</span>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-628">
        Plan Types
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-629">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-630">
          <thead data-id="element-631">
            <tr className="bg-gray-100" data-id="element-632">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-633">
                Type
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-634">
                Frequency Options
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-635">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-636">
            <tr data-id="element-637">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-638">RECURRING</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-639">
                DAILY, WEEKLY, MONTHLY, QUARTERLY, YEARLY
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-640">
                Fixed amount charged at regular intervals
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-641">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-642">INSTALLMENT</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-643">WEEKLY, MONTHLY</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-644">
                Total amount split into equal payments
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}